import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from '../../util/reactIntl';
import css from './WhereWorksBest.module.css';

// Pixel-perfect fix (Figma node 17468:118079): the desktop epic doc confirmed this
// section is "the same underlying data as Suggested Uses, reformatted into grouped,
// bolded-label paragraph form... not a new data field - a display/formatting task."
// Suggested Uses' own entries are plain sentences with no label, so the bold prefix
// this mock shows (e.g. "Urban Environments: Glide through...") has to come from
// parsing a leading "Label:" out of the same string, not a separate field. Only
// splits on a colon found early in the string (<=40 chars in) so a colon appearing
// naturally mid-sentence in an uncategorized entry doesn't get misread as a label -
// those entries fall through to plain text, unchanged from before this fix.
const LABEL_COLON_SEARCH_WINDOW = 40;
const splitLeadingLabel = use => {
  if (typeof use !== 'string') return null;
  const colonIndex = use.indexOf(':');
  if (colonIndex < 0 || colonIndex > LABEL_COLON_SEARCH_WINDOW) return null;
  return {
    label: use.slice(0, colonIndex + 1),
    rest: use.slice(colonIndex + 1),
  };
};

const WhereWorksBest = ({ uses, content }) => {
  const hasUses = Array.isArray(uses) && uses.length > 0;

  if (!hasUses && !content) {
    return null;
  }

  return (
    <section className={css.panel} aria-labelledby="where-works-best-heading">
      <h2 id="where-works-best-heading" className={css.heading}>
        <FormattedMessage
          id="WhereWorksBest.heading"
          defaultMessage="Where This Item Works Best"
        />
      </h2>
      {hasUses ? (
        <div className={css.content}>
          <p>
            <FormattedMessage id="WhereWorksBest.intro" />
          </p>
          <ul className={css.list}>
            {uses.map((use, i) => {
              const split = splitLeadingLabel(use);
              return (
                <li key={i}>
                  {split ? (
                    <>
                      <strong>{split.label}</strong>
                      {split.rest}
                    </>
                  ) : (
                    use
                  )}
                </li>
              );
            })}
          </ul>
          <p>
            <FormattedMessage id="WhereWorksBest.closing" />
          </p>
        </div>
      ) : (
        <div
          className={css.content}
          dangerouslySetInnerHTML={{ __html: content }}
        />
      )}
    </section>
  );
};

WhereWorksBest.propTypes = {
  uses: PropTypes.arrayOf(PropTypes.string),
  content: PropTypes.string,
};

export default WhereWorksBest;
